const Highlight = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.17834 23.29L4.25071 25.3303C3.81543 25.7919 3.96645 26.5766 4.55273 26.8167L7.20878 27.9337C7.54633 28.0722 7.92831 27.9891 8.17703 27.7214L9.30519 26.5212L6.17834 23.29Z"
        fill="#EB3F3F"
      />
      <path
        d="M27.4076 9.05406L25.249 6.82916L23.0904 4.60425C22.3264 3.8103 21.0828 3.8103 20.3188 4.60425L7.60713 17.7506C7.50054 17.8614 7.4117 17.9814 7.34952 18.1199L5.75057 21.5449C5.50184 22.0711 5.60844 22.6989 6.00818 23.1144L7.59825 24.7577L7.91804 25.0808L9.50811 26.7241C9.90785 27.1395 10.5119 27.2411 11.0271 26.9918L14.3405 25.33C14.4738 25.2654 14.5981 25.1731 14.7047 25.0623L27.4253 11.916C28.1893 11.122 28.1893 9.83878 27.4253 9.04483L27.4076 9.05406Z"
        fill="#FFC9C9"
      />
      <path
        d="M23.1019 4.59546L27.4102 9.05451C28.1742 9.84846 28.1742 11.1317 27.4102 11.9257L24.8075 14.6122L17.7188 7.28197L20.3215 4.59546C21.0854 3.80151 22.3291 3.80151 23.093 4.59546H23.1019Z"
        fill="#EB3F3F"
      />
      <path
        d="M26.6274 24.9707H19.0857C18.3351 24.9707 17.7266 25.6031 17.7266 26.3832V26.3924C17.7266 27.1725 18.3351 27.8049 19.0857 27.8049H26.6274C27.378 27.8049 27.9865 27.1725 27.9865 26.3924V26.3832C27.9865 25.6031 27.378 24.9707 26.6274 24.9707Z"
        fill="#EB3F3F"
      />
    </svg>
  );
};

export default Highlight;
